import Container from "@/components/ui/Container";
import travelPng from "@/assets/travel.png";
import { useTranslation } from "react-i18next";

export function AboutUs() {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-12">
      <Container>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div>
            <div className="overflow-hidden">
              {/* Use absolute path relying on Vite public or alias? Or import. Using path assuming src/assets is copied */}
              <img src={travelPng} alt={t('aboutUs.imageAlt')} />
            </div>
          </div>
          <div>
            <div className="mb-6">
              <div className="text-teal-700 text-sm font-semibold uppercase tracking-wide">
                {t('aboutUs.badge')}
              </div>
              <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900">
                {t('aboutUs.title')}
              </h2>
            </div>
            <p className="text-slate-600">
              {t('aboutUs.description')}
            </p>
          </div>
        </div>
      </Container>
    </section>
  );
}
